import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import RenderPdf from '../components/render-pdf'
import {url} from '../components/request-api'
import { Tabs, Tab } from '@material-ui/core';

class TournamentDetail extends Component {
  constructor(props) {
    super(props);      
    this.state = {
      activeTabIndex: 0,
      dayTab: 0 ,
      dayTab2: 0 ,
      scheduleResult:  JSON.parse(atob(this.props.match.params.base))
    }
  
  }

  handleChange = (event, value) => {
    this.setState({ activeTabIndex: value });
  };

  handleChangeDayTab = (event, value) => {
    this.setState({ dayTab: value });
  };
  handleChangeDayTab2 = (event, value) => {
    this.setState({ dayTab2: value });
  };

  render() {
    console.log(this.props);
    const handleClickBack = (id) => {
      this.props.history.push(`/tournament/${this.props.match.params.type}/${localStorage.getItem("i18nextLng")}`)
    };
    const { t } = this.props;
    const { activeTabIndex, dayTab,dayTab2, scheduleResult } = this.state
    return (
    <div id="app">

      <h6 className="text-left back-title cursor" onClick={() => handleClickBack()}><span className="icon-back"><i class="ti-angle-left mr-2 icon-center"></i>{t('backToSchedule')}</span> </h6>

           <section className="services-area">
      <div className="container" style={{"marginBottom": "7rem"}}>
        <div className="project-heading mb-35">
          <div className="row align-items-end">
          <div className="properties__button" style={{overflow: "hidden"}}>
                  <Tabs value={activeTabIndex} onChange={this.handleChange}>
                    <Tab label={t('Details')} />
                    <Tab label={t('applicationForm')} />
                    <Tab label={t('entryList')} />
                    <Tab label={t('yardage')} />
                    <Tab label={t('schedule')} />
                    <Tab label={t('results')} />
                  </Tabs>
              </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12" style={{"text-align": "-webkit-center"}}>
          {
                    activeTabIndex === 0 &&  
                    <div>
                      <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/detail_file`}/>
                    </div>
                  }
                                   {
                    activeTabIndex === 1 &&
                    <div>
                      <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/applicant_form_file`}/>
                    </div>
                  }
                  {
                    activeTabIndex === 2 &&
                    <div>
                        <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/entry_list_file`}/>
                    </div>
                  }                  
                  {
                    activeTabIndex === 3 &&
                    <div>
                       <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/yard_age_file`}/>
                    </div>
                  }
                  {
                    activeTabIndex === 4 &&
                    <div>
                    <div className="properties__button">
                            <Tabs value={dayTab} onChange={this.handleChangeDayTab}>
                            { scheduleResult.schedule_ids.map((item, index)=>(
                              <Tab label={`Day${index+1}`} />
                            ))}
                            </Tabs>
                    </div>
                      {/* <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/detail_file`}/> */}
                          { scheduleResult.schedule_ids.map((item, index)=>(
                          <>
                          {
                          dayTab === index && 
                          <div>
                                <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/schedule/${index+1}`}/>
                            </div>
                          }             
                          </>     
                          ))}
                    </div>
                  }
                  {
                    activeTabIndex === 5 &&
                    <div>
                    <div className="properties__button">
                            <Tabs value={dayTab2} onChange={this.handleChangeDayTab2}>
                            { scheduleResult.result_ids.map((item, index)=>(
                              <Tab label={`Day${index+1}`} />
                            ))}
                            </Tabs>
                    </div>
                      {/* <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/detail_file`}/> */}
                      { scheduleResult.result_ids.map((item, index)=>(
                      <>
                      {
                      dayTab2 === index && 
                      <div>
                            <RenderPdf file={`${url}/tournament/${this.props.match.params.id}/result/${index+1}`}/>
                        </div>
                      }             
                      </>     
                      ))}
                      </div>
                  }
          </div>
        </div>
      </div>
    </section>
    </div>

    );
  }
}

export default withNamespaces()(TournamentDetail);